import { useState, useEffect, useRef } from "react";
import seriesStore from "../stores/seriesStore.js";
import gameResultStore from "../stores/gameResultStore.js";
import Footer from "../components/Footer.js";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Modal from "../components/Misc/Modal.js";
import ErrorPopup from "../components/Misc/ErrorPopup.js";

export default function GamePage() {

    const navigate = useNavigate();
    const serStore = seriesStore();  
    const [selectedShow, setSelectedShow] = useState(null);
    const [selectedSeriesList, setSelectedSeriesList] = useState(null);
    const [activeHeader, setActiveHeader] = useState(false);

    const [hasPlayedToday, setHasPlayedToday] = useState(false); 
    const [guessesLeft, setGuessesLeft] = useState(9);
    const [query, setQuery] = useState("");
     // Mobile overlay
    const [searchBarActive, setSearchBarActive] = useState(false);
    const [categories, setCategories] = useState([]);
  
    // which square they are selecting
    const [selectedBlock, setSelectedBlock] = useState(null);
    const [revealed, setRevealed] = useState([null, null, null, null, null, null, null, null, null]);
    const [tvGrid, setTvGrid] = useState(null);

    const [incorrectBlock, setIncorrectBlock] = useState(null);

    const [isRulesModalOpen, setIsRulesModalOpen] =  useState(false); // Change this to be true when ready
    const [isResultModalOpen, setIsResultModalOpen] =  useState(false);

    const [errorMsg, setErrorMsg] = useState("");
    const [showError, setShowError] = useState(false);
    
    useEffect(() => {
        serStore.fetchSeries();
    }, []);

    useEffect(() => {
        const fetchTvGrid = async () => {
            try {
                const res = await axios.get("/tvgrid");
                setTvGrid(res.data.categories);
            } catch (err) {
                console.error("Failed to fetch tv grid:", err);
            }
        };

        fetchTvGrid();
    }, []);
    

    const filteredSeries = serStore.series?.filter((s) =>
        s.title.toLowerCase().includes(query.toLowerCase())
    );


    const handleBlockClick = (e) => {
        const id = e.currentTarget.id;

        if (!revealed[id]) {
            setSelectedBlock(id);
            getCategories(id); 
            setSearchBarActive(true);
        }
    };


    const getCategories = (selectedBlock) => {
        //use tv grid and selected block to make the list of categories
        let categories = [];

        if (selectedBlock == 0) {
            categories = [tvGrid[0], tvGrid[1], tvGrid[6], tvGrid[7]];
        } else if (selectedBlock === "1") {
            categories = [tvGrid[2], tvGrid[3], tvGrid[6], tvGrid[7]];
        } else if (selectedBlock === "2") {
            categories = [tvGrid[4], tvGrid[5], tvGrid[6], tvGrid[7]];
        } else if (selectedBlock === "3") {
            categories = [tvGrid[0], tvGrid[1], tvGrid[8], tvGrid[9]];
        } else if (selectedBlock === "4") {
            categories = [tvGrid[2], tvGrid[3], tvGrid[8], tvGrid[9]];
        } else if (selectedBlock === "5") {
            categories = [tvGrid[4], tvGrid[5], tvGrid[8], tvGrid[9]];
        } else if (selectedBlock === "6") {
            categories = [tvGrid[0], tvGrid[1], tvGrid[10], tvGrid[11]];
        } else if (selectedBlock === "7") {
            categories = [tvGrid[2], tvGrid[3], tvGrid[10], tvGrid[11]];
        } else if (selectedBlock === "8") {
            categories = [tvGrid[4], tvGrid[5], tvGrid[10], tvGrid[11]];
        }

        setCategories(categories);
    }


    const checkCategory = (category, guess, correctValue) => {
  
        if (category === "network" || category === "airingStatus") {
            if (guess === correctValue) return true;

        } else if (category === "numberOfSeasons") {

            const isOpenEnded = correctValue.includes("+");

            if (isOpenEnded) {
                const min = Number(correctValue.split("+")[0]);
                if (guess >= min) { return true; }
            } else {
                const [min, max] = correctValue.split(" ")[0].split("-").map(Number);
                if (guess >= min && guess <= max) { return true; }
            }

        } else if (category === "genres") {
            if (guess.includes(correctValue)) { return true; }

        } else if (category === "year") {
            const decadeStart = Number(correctValue.replace("s", ""));
            if (guess >= decadeStart && guess < decadeStart + 10) { return true; }
        } 

        return false;
    }

    const checkGuess = (guess) => {
        let correct1 = checkCategory(categories[0], guess[categories[0]], categories[1]);
        let correct2 = checkCategory(categories[2], guess[categories[2]], categories[3]);
        
        if (correct1 && correct2) {
            setRevealed(prev => {
                const next = [...prev];
                next[selectedBlock] = guess;
                return next;
            });
        } else {
            if (correct1) { 
                formatIncorrectGuessMessage(guess.title, categories[2], guess[categories[2]]); 
            } else if (correct2) { 
                formatIncorrectGuessMessage(guess.title, categories[0], guess[categories[0]]); 
            } else {
                formatIncorrectGuessMessage(guess.title, categories[2], guess[categories[2]], categories[0], guess[categories[0]]); 
            }

            runIncorrectGuessAnimation();
        }
        
        setGuessesLeft(prev => Math.max(prev - 1, 0));

        // Add this back once I bring back the results modal
        // if (guessesLeft === 1) {
        //     setIsResultModalOpen(true);
        // }
    };

    const formatIncorrectGuessMessage = (title, category, correctValue, secondCategory, secondCorrectValue) => {
        let incorrectGuess = "Incorrect. " + title;

        if (category === "network") {  incorrectGuess += " is from " + correctValue; }
        else if (category === "airingStatus" && correctValue === "Ended") { incorrectGuess += " has " + correctValue; }
        else if (category === "airingStatus" && correctValue === "Continuing") { incorrectGuess += " is " + correctValue; }
        else if (category === "numberOfSeasons") { 
            incorrectGuess += " has " + correctValue + " season"; 
            if (correctValue != "1") { incorrectGuess += "s" }
        }
        else if (category === "year") {
            incorrectGuess += " began in " + correctValue;
        }
        else if (category === "genres") {
            if (correctValue.length === 1) { 
                incorrectGuess += " is a " + correctValue.join(", ");
            } else {
                incorrectGuess += " is " + correctValue.join(", ");
            }
        }

        if (secondCategory) {
            if (secondCategory === "network") {  incorrectGuess += " and is from " + secondCorrectValue; }
            else if (secondCategory === "airingStatus" && secondCorrectValue === "Ended") { incorrectGuess += " and has " + secondCorrectValue; }
            else if (secondCategory === "airingStatus" && secondCorrectValue === "Continuing") { incorrectGuess += " and is " + secondCorrectValue; }
            else if (secondCategory === "numberOfSeasons") { 
                incorrectGuess += " and has " + secondCorrectValue + " season"; 
                if (secondCorrectValue != "1") { incorrectGuess += "s" }
            }
            else if (secondCategory === "year") {
                incorrectGuess += " and began in " + secondCorrectValue;
            }
            else if (secondCategory === "genres" && category != "genres") {
                if (secondCorrectValue.length === 1) { 
                    incorrectGuess += " and is a " + secondCorrectValue.join(", ");
                } else {
                    incorrectGuess += " and is " + secondCorrectValue.join(", ");
                }
            }
        }

        setErrorMsg(incorrectGuess);
        setShowError(true);
    }

    const runIncorrectGuessAnimation = (id) => {
        setIncorrectBlock(selectedBlock);
        setTimeout(() => setIncorrectBlock(null), 300); 
    }

    return (
        <div className="app-wrapper tv-static">
            <header class="gpHeader">
                <h1 className="scopedLogo" onClick={() => {
                        setSelectedShow(null);
                        setSelectedSeriesList(null);
                        setActiveHeader(null);
                        navigate("/");
                    }}>ScopedTV</h1>
               
            </header>
            <div className="gpContent">
                <div className="gamePage">
                    <div>
                        <div className="gp2Header"> 
                            <h3>TV Grid</h3>
                            <p className="gp2-secondary-text">Choose one television series for each block. It must match the row and column's criteria. Complete the grid in 9 guesses.</p>
                            {(!hasPlayedToday) && (<div> 
                                <p className="gp2-guess-text">Guesses left: {guessesLeft}</p>
                            </div> 
                            )}
                            
                        </div>
                            
                        <div className="gp2Grid">
                            <div class="gp2GridHeader">
                                 <div className="gp2GridXAxisText"></div>
                                 <div className="gp2GridXAxisText"><p>{tvGrid?.[1]}</p></div>
                                 <div className="gp2GridXAxisText"><p>{tvGrid?.[3]}</p></div>
                                 <div className="gp2GridXAxisText"><p>{tvGrid?.[5]}</p></div>
                            </div>
                            <div class="gp2Row">
                                <div className="gp2GridYAxisText"><p>{tvGrid?.[7]}</p></div>
                                
                                <div 
                                    id="0" 
                                    className={`gp2Block ${selectedBlock === "0" ? "selectedBlock" : ""} ${incorrectBlock === "0" ? "incorrectBlock" : ""}`}
                                    onClick={handleBlockClick}>
                                        {revealed[0] != null ? (
                                            <img src={revealed[0].poster} alt={revealed[0].title} className="gp2SeriesImage"/>
                                        ) : null}
                                </div>
                                <div 
                                    id="1" 
                                    className={`gp2Block ${selectedBlock === "1" ? "selectedBlock" : ""} ${incorrectBlock === "1" ? "incorrectBlock" : ""}`}
                                    onClick={handleBlockClick}>
                                        {revealed[1] != null ? (
                                            <img src={revealed[1].poster} alt={revealed[1].title} className="gp2SeriesImage"/>
                                        ) : null}
                                </div>
                                <div 
                                    id="2" 
                                    className={`gp2Block ${selectedBlock === "2" ? "selectedBlock" : ""} ${incorrectBlock === "2" ? "incorrectBlock" : ""}`}
                                    onClick={handleBlockClick}>
                                        {revealed[2] != null ? (
                                            <img src={revealed[2].poster} alt={revealed[2].title} className="gp2SeriesImage"/>
                                        ) : null}
                                </div>
                            </div>
                            <div className="gp2Row">
                                <div class="gp2GridYAxisText"><p>{tvGrid?.[9]}</p></div>
                                <div 
                                    id="3" 
                                    className={`gp2Block ${selectedBlock === "3" ? "selectedBlock" : ""} ${incorrectBlock === "3" ? "incorrectBlock" : ""}`}
                                    onClick={handleBlockClick}>
                                        {revealed[3] != null ? (
                                            <img src={revealed[3].poster} alt={revealed[3].title} class="gp2SeriesImage"/>
                                        ) : null}
                                </div>
                                <div 
                                id="4" 
                                className={`gp2Block ${selectedBlock === "4" ? "selectedBlock" : ""} ${incorrectBlock === "4" ? "incorrectBlock" : ""}`}
                                onClick={handleBlockClick}>
                                    {revealed[4] != null ? (
                                        <img src={revealed[4].poster} alt={revealed[4].title} class="gp2SeriesImage"/>
                                    ) : null}
                                </div>
                                <div 
                                id="5" 
                                className={`gp2Block ${selectedBlock === "5" ? "selectedBlock" : ""} ${incorrectBlock === "5" ? "incorrectBlock" : ""}`}
                                onClick={handleBlockClick}>
                                    {revealed[5] != null ? (
                                        <img src={revealed[5].poster} alt={revealed[5].title} class="gp2SeriesImage"/>
                                    ) : null}
                                </div>
                            </div>
                            <div class="gp2Row">
                                <div class="gp2GridYAxisText"><p>{tvGrid?.[11]}</p></div>
                                <div 
                                    id="6" 
                                    className={`gp2Block ${selectedBlock === "6" ? "selectedBlock" : ""} ${incorrectBlock === "6" ? "incorrectBlock" : ""}`}
                                    onClick={handleBlockClick}>
                                        {revealed[6] != null ? (
                                            <img src={revealed[6].poster} alt={revealed[6].title} class="gp2SeriesImage"/>
                                    ) : null}
                                </div>
                                <div
                                    id="7"
                                    className={`gp2Block ${selectedBlock === "7" ? "selectedBlock" : ""} ${incorrectBlock === "7" ? "incorrectBlock" : ""}`}
                                    onClick={handleBlockClick}>
                                        {revealed[7] != null ? (
                                            <img src={revealed[7].poster} alt={revealed[7].title} className="gp2SeriesImage"/>
                                        ) : null}
                                </div>
                                <div
                                    id="8"
                                    className={`gp2Block ${selectedBlock === "8" ? "selectedBlock" : ""} ${incorrectBlock === "8" ? "incorrectBlock" : ""}`}
                                    onClick={handleBlockClick}>
                                        {revealed[8] != null ? (
                                            <img src={revealed[8].poster} alt={revealed[8].title} className="gp2SeriesImage"/>
                                        ) : null}
                                </div>
                            </div>
                            
                        </div>  
                    </div>
                

                    
                </div>
            </div>

            <footer class="footer"><Footer></Footer></footer>
            
            <div>
                {/* MOBILE SEARCH BAR - OVERLAY */}
                {searchBarActive &&  (
                    <div className="gpGridGameSearchOverlay">
                        <div className="gpGridGameSearchOverlayHeader">
                            <p className="gpGridGameSearchOverlayHeaderText">{categories[1]} and {categories[3]}</p>                        
                            <button className="gpGridGameSearchOverlayCloseBtn" onClick={() => setSearchBarActive(false)}>
                                <img class="gpGridGameHeaderIconClose" src="/assets/icons/close-white.png"></img></button>
                        </div>
                        <div className="mobileSearchBar">
                            <input
                                autoFocus
                                type="text"
                                placeholder="search"
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && filteredSeries?.length > 0) {
                                        setSearchBarActive(false);
                                        checkGuess(filteredSeries[0]);
                                        setQuery("");
                                    }
                                }}
                            />
                        </div> 
                        <div className="mobileSearchResults">
                            {filteredSeries?.map((s) => (
                            <div
                                key={s._id}
                                className="mobileSearchResultItem"
                                onClick={() => {
                                    setSearchBarActive(false);
                                    checkGuess(s);
                                    setQuery("");
                                }}
                            >
                                {s.title}
                            </div>
                            ))}
                        </div>
                    </div>
                )}</div>

                <Modal
                    isOpen={isRulesModalOpen}
                    onClose={() => setIsRulesModalOpen(false)}
                    title="How to Play"
                >
                    <p>Choose one television series for each block. It must match the row and column's criteria. Complete the grid in 9 guesses.</p>
                    <p className="modal-secondary-text">Multiple series will fit the criteria.<br></br><br></br>
                        The decade is based on the year the series began.<br></br><br></br>
                        The network is the original network that created the series and may not be where it's currently available.
                    </p>
                    <button className="modal-button" onClick={() => setIsRulesModalOpen(false)}>Let's Play!</button>
                </Modal>

                {/* <Modal
                    isOpen={isResultModalOpen}
                    onClose={() => setIsResultModalOpen(false)}
                    title="Game Summary"
                >
                    <p>? / 9 </p>
                    <button className="modal-button" onClick={() => setIsResultModalOpen(false)}>Keep Playing</button>
                    <button className="modal-button" onClick={() => setIsResultModalOpen(false)}>View Results</button>
                </Modal> */}

                <ErrorPopup 
                    message={errorMsg} 
                    show={showError} 
                    onDone={() => setShowError(false)} 
            />
        </div>
    )
}